module.exports = __webpack_public_path__ + "img/0Q3C6212_Wood.2a347d6e.jpg";